import Duck from "redux-ducks-ts"

export const customer = new Duck("customer", "cargo")
